// ScrollContainer.js - 基类组件
import React from 'react';

import styles from './view/lanhu_15hezuoyuanxiao/assets/indexResponse.module.css';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const universitiesList =
    [
        {
            "country": "西班牙",
            "country_code": "ES",
            "universities": [
                {
                    "university_code": "UB",
                    "name": "巴塞罗那大学",
                    "background_image": "ES-Ub.png",
                    "introduction": "是西班牙最古老的大学之一，医学、人文、理学及商科等领域具有显著优势。",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UAB",
                    "name": "巴塞罗那自治大学",
                    "background_image": "ES-Uab.png",
                    "introduction": "‌是一所国际认可度高、学术实力强劲的西班牙顶尖研究型大学。‌",
                    "isHasLogo": true,
                    "photoNumbers": 3,
                },
                {
                    "university_code": "UPC",
                    "name": "加泰罗尼亚理工大学",
                    "background_image": "ES-Upc.png",
                    "introduction": "是一所优秀的理工大学，具有较高的国际声誉和良好的教学质量。",
                    "isHasLogo": true,
                    "photoNumbers": 4,
                },
                {
                    "university_code": "UPF",
                    "name": "庞培法布拉大学",
                    "background_image": "ES-Upf.png",
                    "introduction": "庞培法布拉大学位列西班牙第3名，世界第175名‌",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UDG",
                    "name": "赫罗纳大学",
                    "background_image": "ES-Udg.png",
                    "introduction": "是一所备受认可的公立大学，位于西班牙东北部的赫罗纳市。",
                    "isHasLogo": true,
                    "photoNumbers": 3,
                },
                {
                    "university_code": "UDL",
                    "name": "莱里达大学",
                    "background_image": "ES-Udl.png",
                    "introduction": "是一所优秀的公立大学，位于西班牙加泰罗尼亚自治区的莱里达市。",
                    "isHasLogo": true,
                    "photoNumbers": 3,
                },
                {
                    "university_code": "URV",
                    "name": "罗维拉·依维尔基里大学",
                    "background_image": "ES-Urv.png",
                    "introduction": "是一所优秀的综合性公立大学，具有卓越的教学质量和研究成果。",
                    "isHasLogo": true,
                    "photoNumbers": 4,
                },
                {
                    "university_code": "UVIC",
                    "name": "维克-中加泰罗尼亚大学",
                    "background_image": "ES-Uvic.png",
                    "introduction": "是一所优秀的私立大学，具有较高的教育质量和国际认可度。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UV",
                    "name": "瓦伦西亚大学",
                    "background_image": "ES-Uv.png",
                    "introduction": "是一所西班牙历史悠久的公立研究型大学，在学术声誉、专业优势和留学性价比方面表现突出，是一所值得考虑的优质学府。",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UPV",
                    "name": "瓦伦西亚理工大学",
                    "background_image": "ES-Upv.png",
                    "introduction": "是一所优秀的大学，具有较高的学术声誉和良好的教育资源。",
                    "isHasLogo": true,
                    "photoNumbers": 4,
                },
                {
                    "university_code": "UA",
                    "name": "阿利坎特大学",
                    "background_image": "ES-Ua.png",
                    "introduction": "是一所优秀的公立大学，具有卓越的学术声誉和丰富的教育资源。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UJI",
                    "name": "海梅一世大学",
                    "background_image": "ES-Uji.png",
                    "introduction": "是一所优秀的公立研究型大学，具有较高的学术水平和良好的教学环境。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UMH",
                    "name": "米格尔·埃尔南德斯·德埃尔切大学",
                    "background_image": "ES-Umh.png",
                    "introduction": "是一所充满活力的年轻大学，成立于1997年，位于西班牙瓦伦西亚自治区阿利坎特省的埃尔切市。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },

            ]
        },
        {
            "country": "马来西亚",
            "country_code": "MY",
            "universities": [
                {
                    "university_code": "UM",
                    "name": "马来亚大学",
                    "background_image": "MY-Um.png",
                    "introduction": "文理学科和医学兼有的综合性大学，是马来西亚规模最大和最著名的大学之一，也是环太平洋大学联盟重要的学术成员。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "USM",
                    "name": "理科大学",
                    "background_image": "MY-USM.png",
                    "introduction": "是大马建立的第二所国立大学，也是马来西亚五所研究密集型大学之一。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UPM",
                    "name": "布特拉大学",
                    "background_image": "MY-UPM.png",
                    "introduction": "是一所马来西亚公立综合性研究型大学。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UKM",
                    "name": "国民大学",
                    "background_image": "MY-UKM.png",
                    "introduction": "马来西亚国民大学是马来西亚五所研究性大学之一。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "UMS",
                    "name": "沙巴大学",
                    "background_image": "MY-UMS.png",
                    "introduction": "是马来西亚第九所国立大学。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "MONASH",
                    "name": "莫纳什大学",
                    "background_image": "MY-MONASH.png",
                    "introduction": "是澳大利亚最大大学的第三大校园，也是马来西亚第一所外国大学校园。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "TAYLORS",
                    "name": "泰莱大学",
                    "background_image": "MY-TAYLORS.png",
                    "introduction": "马来西亚最杰出的私立大学之一，享有崇高的声誉。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "APU",
                    "name": "亚太科技大学",
                    "background_image": "MY-APU.png",
                    "introduction": "前身是成立于1993年的亚太资讯工艺学院（APIIT），是马来西亚顶级数字技术大学。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "MMU",
                    "name": "多媒体大学",
                    "background_image": "MY-MMU.png",
                    "introduction": "该大学也是亚太地区硅谷—多媒体超级走廊（MSC）的成员，支持并推动着MSC及整个国家发展，也被誉为“马来西亚的清华大学”。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "CYBERJAYA",
                    "name": "赛城大学",
                    "background_image": "MY-CYBERJAYA.png",
                    "introduction": "成立于 2005 年，最初名为赛城大学医学院（CUCMS）。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "NEWERA",
                    "name": "新纪元大学学院",
                    "background_image": "MY-NEWERA.png",
                    "introduction": "马来西亚华人于1997年倾注全国华人心血，筹募基金而成立的一所综合类大学。",
                    "isHasLogo": true,
                    "photoNumbers": 2,
                },
                {
                    "university_code": "JINYIN",
                    "name": "精英大学",
                    "background_image": "MY-JINYIN.jpg",
                    "introduction": "是一所私立高等学府，以卓越的教学和师资力量闻名。",
                    "isHasLogo": true,
                    "photoNumbers": 3,
                },
                {
                    "university_code": "JILONGPO",
                    "name": "基隆坡基础大学",
                    "background_image": "MY-JILONGPO.jpg",
                    "introduction": "该校在工程、建筑、商业管理等领域享有较高声誉。",
                    "isHasLogo": true,
                    "photoNumbers": 4,
                },
                {
                    "university_code": "MASA",
                    "name": "马萨大学",
                    "background_image": "MY-MASA.jpg",
                    "introduction": "是一所私立大学，以医学和健康科学领域闻名。该校是马来西亚最大的私立医学院之一，其医学、药剂学等专业在东南亚地区享有盛誉。",
                    "isHasLogo": true,
                    "photoNumbers": 3,
                },
                {
                    "university_code": "UTP",
                    "name": "马来西亚国油科技大学",
                    "background_image": "MY-UTP.png",
                    "introduction": "是马来西亚领先的私立研究型大学。该校在2024年QS世界大学排名中位列第307位。",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UOSM",
                    "name": "马来西亚南安普顿大学",
                    "background_image": "MY-UOSM.png",
                    "introduction": "也叫英国南安普顿大学马来西亚校区、英国南安普顿大学马来西亚分校。",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UTN",
                    "name": "马来西亚国家能源大学",
                    "background_image": "MY-UTN.png",
                    "introduction": "马来西亚国家能源大学成立于1997年，隶属于马来西亚国家能源公司，是一所以工程、电脑与资讯科技、工商管理等学科为主的私立大学。",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },

            ]
        },
        {
            "country": "英国",
            "country_code": "GB",
            "universities": [
                {
                    "university_code": "UCL",
                    "name": "伦敦大学学院",
                    "background_image": "UK-London.png",
                    "introduction": "英国顶尖研究型大学，医学与人文并重",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "EDIN",
                    "name": "爱丁堡大学",
                    "background_image": "UK-Edinburgh.png",
                    "introduction": "苏格兰名校，医学与历史学科著称",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UoM",
                    "name": "曼彻斯特大学",
                    "background_image": "UK-Manchester.png",
                    "introduction": "红砖大学，理工科与商科并重",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UoB",
                    "name": "伯明翰大学",
                    "background_image": "UK-Birmingham.png",
                    "introduction": "英国顶尖学府，以钟楼为标志",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Leeds",
                    "name": "利兹大学",
                    "background_image": "UK-Leeds.png",
                    "introduction": "红砖大学，以商学和工程见长",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Glasgow",
                    "name": "格拉斯哥大学",
                    "background_image": "UK-Glasgow.png",
                    "introduction": "苏格兰最古老大学，医学与神学闻名",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Sheffield",
                    "name": "谢菲尔德大学",
                    "background_image": "UK-Sheffield.jpg",
                    "introduction": "红砖大学，工程与材料科学领先",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Newcastle",
                    "name": "纽卡斯尔大学",
                    "background_image": "SING-Newcastle.jpg",
                    "introduction": "英格兰东北部名校，医学与工程并重",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Lancaster",
                    "name": "兰卡斯特大学",
                    "background_image": "UK-Lancaster.jpg",
                    "introduction": "英国顶尖商学院，以管理学著称",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                }
            ]
        },
        {
            "country": "美国",
            "country_code": "US",
            "universities": [
                {
                    "university_code": "UC Davis",
                    "name": "加州大学戴维斯分校",
                    "background_image": "USA-California.jpg",
                    "introduction": "美国公立常春藤，农业与兽医领先",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UCI",
                    "name": "加州大学欧文分校",
                    "background_image": "USA-California.jpg",
                    "introduction": "加州顶尖公立大学，计算机与医学突出",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UCSB",
                    "name": "加州大学圣巴巴拉分校",
                    "background_image": "USA-California2.jpg",
                    "introduction": "海滨研究型大学，环境科学与工程强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "CWRU",
                    "name": "凯斯西储大学",
                    "background_image": "USA-CWRU.jpg",
                    "introduction": "美国顶尖私立大学，医学与工程闻名",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Purdue",
                    "name": "普渡大学",
                    "background_image": "USA-Purdue.png",
                    "introduction": "美国工科强校，航天与工程领先",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "OSU",
                    "name": "俄亥俄州立大学",
                    "background_image": "USA- Ohio.jpeg",
                    "introduction": "美国最大公立大学，商学与体育强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "PSU",
                    "name": "宾夕法尼亚州立大学",
                    "background_image": "USA-Pennsylvania.png",
                    "introduction": "美国顶尖公立大学，工程与农业突出",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                }
            ]
        },
        {
            "country": "澳大利亚",
            "country_code": "AU",
            "universities": [
                {
                    "university_code": "USYD",
                    "name": "悉尼大学",
                    "background_image": "AU-SYDNEY.png",
                    "introduction": "澳大利亚最古老大学，医学与法律强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UNSW",
                    "name": "新南威尔士大学",
                    "background_image": "AU-NewSouthWales.png",
                    "introduction": "澳大利亚顶尖理工大学，工程与商科强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "ANU",
                    "name": "澳大利亚国立大学",
                    "background_image": "AU-ANU.png",
                    "introduction": "澳大利亚顶尖研究型大学，政治与科学强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UniMelb",
                    "name": "墨尔本大学",
                    "background_image": "AU-Melbourne.jpeg",
                    "introduction": "澳大利亚顶尖大学，医学与法律闻名",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UQ",
                    "name": "昆士兰大学",
                    "background_image": "AU-UQ.jpg",
                    "introduction": "澳大利亚顶尖公立大学，农业与环境强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Monash",
                    "name": "莫纳什大学",
                    "background_image": "AU-Monash.png",
                    "introduction": "澳大利亚规模最大大学，医学与商科强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                }
            ]
        },
        {
            "country": "新加坡",
            "country_code": "SG",
            "universities": [
                {
                    "university_code": "UoB-SG",
                    "name": "伯明翰大学新加坡分校",
                    "background_image": "UK-Birmingham.png",
                    "introduction": "新加坡分校，继承英国本校学术传统",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Curtin-SG",
                    "name": "科廷大学新加坡分校",
                    "background_image": "SING-Curtin.png",
                    "introduction": "新加坡分校，提供应用型课程",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Newcastle-SG",
                    "name": "纽卡斯尔大学新加坡分校",
                    "background_image": "SING-Newcastle.jpg",
                    "introduction": "新加坡分校，医学与工程并重",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UCD-SG",
                    "name": "都柏林大学学院新加坡分校",
                    "background_image": "SING-Ucd.png",
                    "introduction": "新加坡分校，商科与计算机强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "UOW-SG",
                    "name": "伍伦贡大学新加坡分校",
                    "background_image": "SING-UOW-SG.png",
                    "introduction": "新加坡分校，工程与IT领域突出",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "RMIT-SG",
                    "name": "皇家墨尔本理工大学新加坡校区",
                    "background_image": "SING-RMIT-SG.png",
                    "introduction": "新加坡分校，艺术与设计领先",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                }
            ]
        },

        {
            "country": "中国香港",
            "country_code": "HK",
            "universities": [
                {
                    "university_code": "PolyU",
                    "name": "香港理工大学",
                    "background_image": "HK-PolyU.png",
                    "introduction": "香港顶尖理工大学，设计与工程强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "HKBU",
                    "name": "香港浸会大学",
                    "background_image": "HK-HKBU.png",
                    "introduction": "香港私立大学，传媒与中医突出",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Lingnan",
                    "name": "香港岭南大学",
                    "background_image": "HK-Lingnan.png",
                    "introduction": "香港博雅教育代表，人文与社科强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "HKMU",
                    "name": "香港都会大学",
                    "background_image": "HK-HKMU.png",
                    "introduction": "香港公立大学，开放教育与商科强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "EdUHK",
                    "name": "香港教育大学",
                    "background_image": "HK-EdUHK.jpeg",
                    "introduction": "香港唯一师范大学，教育研究领先",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "HKSYU",
                    "name": "香港树仁大学",
                    "background_image": "HK-HKSYU.jpg",
                    "introduction": "香港私立大学，法律与商科突出",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                }
            ]
        },
        {
            "country": "日本",
            "country_code": "JP",
            "universities": [
                {
                    "university_code": "Kyoto-U",
                    "name": "京都大学",
                    "background_image": "JAPAN-Kyoto.png",
                    "introduction": "日本顶尖大学，樟树与钟楼象征学术",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Waseda",
                    "name": "早稻田大学",
                    "background_image": "JAPAN-Waseda.png",
                    "introduction": "日本私立双雄之一，政治与经济强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Keio",
                    "name": "庆应义塾大学",
                    "background_image": "JAPAN-Keio.png",
                    "introduction": "日本私立顶尖大学，商学与医学强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Nagoya-U",
                    "name": "名古屋大学",
                    "background_image": "JAPAN-Nagoya.png",
                    "introduction": "日本顶尖国立大学，医学与工程强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                },
                {
                    "university_code": "Osaka-U",
                    "name": "大阪大学",
                    "background_image": "JAPAN-OsakaU.jpg",
                    "introduction": "日本顶尖国立大学，医学与理学强",
                    "isHasLogo": true,
                    "photoNumbers": 0,
                }
            ]
        },

    ];
class Universities extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data_list: [],
            colors: ["#d3292f", "#004c23", "#1a3a59", "#243e8d", "#69b3e7"]
        };
        universitiesList.map(countryItem => {
            countryItem.universities.map(item => {
                this.state.data_list.push({ ...item, country: countryItem.country, country_code: countryItem.country_code })
            })
        })
    }
    onGotoUniversty = (value) => {
        window.location.href = ""
    }
    onRenderItem = (item, index) => {
        return <div className={'flex-col dv_unvierst_item'}>
            <div class="university-card_uni_card_top__eMRzY" style={{ backgroundColor: `${this.state.colors[index % 5]}` }}></div>
            <div className="flex-col">
                <div className='dv_bg_guojia'>
                    <img src={require("./assets/img/unviserty/" + item.background_image)} />
                </div>
                <div className='dv_item_wrapintroud'>
                    <div className="text_itemname">{item.name}</div>
                    <div className='dv_intoudction'>{item.introduction}</div>
                    <div class="align-items-end d-flex justify-content-between mt-auto">
                        <div class="university-card_uni_card_footer__4FmR_"></div>
                        <div class="university-card_uni_card_pill_wrapper__sMk6Z justify-items-end flex-row">
                            <div class="country-pill_pill__oEbGd country-pill d-flex flex-row">
                                <img src={require(`./assets/img/flag/${item.country_code}.svg`)} height="15" width="15" alt="Flag of the United Kingdom" />
                                <span class="country-pill_pill_label__AzqRb align-items-center">{item.country}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    }

    render() {
        let { data_list } = this.state;
        return (
            <div id="mainwrap" ref={this.scrollContainer} style={{
                height: '100vh',
                overflowY: 'scroll',
                scrollSnapType: 'y mandatory',
                scrollBehavior: 'smooth'
            }}
            >
                <Header activeMenu="7" />
                <div className={`${styles.page} flex-col indexResponse_page__22n8A`}>
                    <div className="">
                        <div className="dv_main_contentwrap">
                            <div className="flex-col">
                                <div className='flex-row universities-filter_filter_buttons__dsksN align-items-center'>

                                    <ul className='dv_select_country_wrap'>
                                        <li className={` ${!this.state.filterCountry ? 'choose' : ''}`} onClick={() => {
                                            this.setState({ 'filterCountry': '' })
                                        }}>全部</li>{
                                            universitiesList.map(item => {
                                                return (<li className={`clickable ${this.state.filterCountry == item.country_code ? 'choose' : ''}`} onClick={() => {
                                                    this.setState({ 'filterCountry': item.country_code })
                                                }}>{item.country}</li>)
                                            })
                                        }</ul></div>
                                <div className="dv_list_item_wrap">
                                    {data_list.filter(a => {
                                        return (!this.state.filterCountry || this.state.filterCountry == a.country_code);
                                    }).sort((a, b) => b.photoNumbers - a.photoNumbers).map((item, index) => {
                                        if (item.photoNumbers > 0) {
                                            return (
                                                <Link to={`/university/${item.university_code}`} className="clickable">
                                                    {this.onRenderItem(item, index)}
                                                </Link>
                                            )
                                        } else {
                                            { return (this.onRenderItem(item, index)) }
                                        }

                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <Footer />
            </div >
        );
    }
}

export { Universities, universitiesList };